import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { userSchema } from '../schemas/user.schema';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get a User by its External ID
 * @param externalId External ID of the User
 * @returns A data object containing an array of 1 user
 */
export function getUsersExternalId(this: unknown, externalId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersUrl}/${encodeURIComponent(
          externalId
        )}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(
          userSchema.extend({
            externalName: z.string().nullable(),
          })
        ),
      })
    )
  );
}
